import React from "react";
import { connect } from "react-redux";
import { setEditData, setModalTemplate, setModalType, setShowEditItemGroupModal, setShowEditItemTaxModal } from '../../redux/modal/modal.actions';
import { createStructuredSelector } from 'reselect';
import { selectEditUUID, selectModalFormTemplate, selectShowEditItemGroupModal, selectShowEditItemTaxModal } from "../../redux/modal/modal.reselect";
import { useEffect } from "react";

import EDIT_ITEM_TAX_FORM_TEMPLATE from './edit-item-tax.template';

import ModalContainer from "../modal/modal.container";
import useFetchEdit from "../../effects/use-fetch-edit.effect";
import { authTokenSelector } from "../../redux/user/user.reselect";

const EditItemGroup = ({
    showEditItemTax,
    setModalTemplate,
    setModalType,
    formTemplate,
    editUUID,
    authToken,
    setShowEditItemTaxModal,
    isFetching,
    setEditData
}) => {
    useEffect(() => {
        setModalType("EDIT_ITEM_TAX")
        setModalTemplate(EDIT_ITEM_TAX_FORM_TEMPLATE);
    }, []);
    const endpoint = '/itemtaxes';
    const endpointUrl = endpoint + '/' + editUUID;
    const authTokenFromState = authToken;

    const { data, error } = useFetchEdit(endpointUrl, authTokenFromState, showEditItemTax);

    useEffect(() => {
        setEditData(data)
    })
    
    return (
        <div className="edit-item-group">
            {
                Object.keys(formTemplate).length > 0 ?
                    <ModalContainer
                        showModal={showEditItemTax}
                        setShowModal={setShowEditItemTaxModal}
                        endpointUrl={endpointUrl}
                        size={"MEDIUM"}
                    />
                    : null
            }
        </div>
    )
}

const mapStateToProps = createStructuredSelector({
    showEditItemTax: selectShowEditItemTaxModal,
    formTemplate: selectModalFormTemplate,
    editUUID: selectEditUUID,
    authToken: authTokenSelector,
})

const mapDispatchToProps = (disptach) => ({
    setShowEditItemTaxModal: () =>
        disptach(setShowEditItemTaxModal()),
    setModalTemplate: (formTemplate) =>
        disptach(setModalTemplate(formTemplate)),
    setModalType: (modalType) =>
        disptach(setModalType(modalType)),
    setEditData: (editData) =>
        disptach(setEditData(editData))
})


export default connect(mapStateToProps, mapDispatchToProps)(EditItemGroup);